import styled from 'styled-components';

import { useGetMicrostoreColumnsPaginatedQuery, type MicrostoreColumnsFilterInput } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { templateColumnsListColumns, type TemplateColumnRow } from '../constants/templateColumnsListColumns';

// La table est triée et filtrée côté client : il faut toute la liste (l'API tronque à 30 par défaut).
const COLUMNS_LIMIT = 1000;

export const MicrostoreColumnTemplateColumnsList = ({
    microstoreColumnTemplateName,
}: {
    microstoreColumnTemplateName: string;
}) => {
    const filters: MicrostoreColumnsFilterInput = { microstoreColumnTemplateName };

    const { data, loading, error } = useGetMicrostoreColumnsPaginatedQuery({
        variables: { filters, offset: 0, limit: COLUMNS_LIMIT },
    });

    if (error) {
        return <ErrorMessage>Erreur lors de la récupération des colonnes</ErrorMessage>;
    }

    const microstoreColumns = data?.microstoreColumnsFilter.microstoreColumns ?? [];

    return (
        <>
            {data?.microstoreColumnsFilter.hasMore ? (
                <TruncationNotice>Liste tronquée aux {COLUMNS_LIMIT} premières colonnes.</TruncationNotice>
            ) : null}
            <DataTable<TemplateColumnRow>
                columns={templateColumnsListColumns}
                data={microstoreColumns}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/microstore-column/${row._id}`}
                isLoading={loading}
                disableColumnVisibility
                disableUrlSync
                autoFocusSearch={false}
            />
        </>
    );
};

const ErrorMessage = styled.div`
    color: ${({ theme }) => theme.errorColor};
    padding: 10px;
`;

const TruncationNotice = styled.div`
    color: ${({ theme }) => theme.infoTextColor};
    padding-bottom: 10px;
`;
